import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'rawHtml', pure: false })
export class RawHtmlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) { }

  transform(content: string) {
    return this.domSanitizer.bypassSecurityTrustHtml(content);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/raw-html/raw-html.ts